module.exports = __webpack_public_path__ + "static/media/iphone-frame-charcoal-grey.8a9bae0a.svg";